export default function(state = {}, action) {
  const typeMap = {
    HUB_PAGE_LOADING() {
      return {
        isLoading: true,
        hubPage: {}
      };
    },
    HUB_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.hubPage
      };
    },
    HUB_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.hubPage.errorMessage,
        hubPage: {}
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
